import { render, staticRenderFns } from "./StrapiMarkdownComponent.vue?vue&type=template&id=eb6b7e84"
import script from "./StrapiMarkdownComponent.vue?vue&type=script&lang=js"
export * from "./StrapiMarkdownComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports